import React, { Component } from 'react';
import Header from '../common/layout/header'; 
import Footer from '../common/layout/footer';
import DocumentIco from '../assets/images/doc-ico.png';
import Pdf from '../assets/docs/Lorem_ipsum.pdf';

class Product extends Component {

    constructor(props){
    super(props)
    if(!localStorage.getItem("isLoggedIn"))
    window.location.href = '/';
    }

    render(){

        return(
        <>
        <Header/>
                
                <section className="cater-block">
                    <div className="sm-container">

                        <div className="cater-sec">
                            <h1>ALLERGENS, NUTRITIONAL INFO & PRODUCT SPECIFICATIONS</h1>
                            <div className="cater-prot-flx">
                                
                                <div className="prot-itme">
                                    <a className="prot-innr" href={Pdf} target="_blank">
                                        <div className="prot-ico">
                                            <img src={DocumentIco} alt="document" />
                                        </div>
                                        <span>Pizza Allergens.pdf</span>
                                    </a>
                                </div>
                                <div className="prot-itme">
                                    <a className="prot-innr" href={Pdf}>
                                        <div className="prot-ico">
                                            <img src={DocumentIco} alt="document" />
                                        </div>
                                        <span>Pasta, Rice & Noodle sauces Allergens.pdf</span>
                                    </a>
                                </div>
                                <div className="prot-itme">
                                    <a className="prot-innr" href={Pdf}>
                                        <div className="prot-ico">
                                            <img src={DocumentIco} alt="document" />
                                        </div>
                                        <span>Burrito Allergens.pdf</span>
                                    </a>
                                </div>
                                <div className="prot-itme">
                                    <a className="prot-innr" href={Pdf}>
                                        <div className="prot-ico">
                                            <img src={DocumentIco} alt="document" />
                                        </div>
                                        <span>Pizza Nutritional Info.pdf</span>
                                    </a>
                                </div>
                                <div className="prot-itme">
                                    <a className="prot-innr" href={Pdf}>
                                        <div className="prot-ico">
                                            <img src={DocumentIco} alt="document" />
                                        </div>
                                        <span>Pasta, Rice & Noodle sauces Nutritional Info.pdf</span>
                                    </a>
                                </div> 
                                <div className="prot-itme">
                                    <a className="prot-innr" href={Pdf}>
                                        <div className="prot-ico">
                                            <img src={DocumentIco} alt="document" />
                                        </div>
                                        <span>Burrito Nutritional Info.pdf</span>
                                    </a>
                                </div> 
                                <div className="prot-itme">
                                    <a className="prot-innr" href={Pdf}>
                                        <div className="prot-ico">
                                            <img src={DocumentIco} alt="document" />
                                        </div>
                                        <span>Product Specifications.pdf</span>
                                    </a>
                                </div>
                                <div className="prot-itme">
                                    <a className="prot-innr" href={Pdf}>
                                        <div className="prot-ico">
                                            <img src={DocumentIco} alt="document" />
                                        </div>
                                        <span>All Products Info.pdf</span>
                                    </a>
                                </div>

                            </div>
                        </div>

                    </div>
                </section>

            <Footer/>
        </>
        );
    }
}

export default Product;